import * as Legacy from '../..'

export function convertPlainText(text: string) {
  return {
    editorState: Legacy.getBlockValueFromAnyValue(text),
  }
}
